<template>
  <vx-card title="Publicaciones Blog">

    <div
      id="data-list-list-view"
      class="data-list-container"
      v-if="posts.length >= 1"
    >
      <data-view-sidebar
        :isSidebarActive="addNewDataSidebar"
        @closeSidebar="toggleDataSidebar"
        :data="sidebarData"
      />

      <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPage"
        search
        :data="posts"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ACTION - DROPDOWN -->
            <!-- <vs-dropdown
              vs-trigger-click
              class="dd-actions cursor-pointer mr-4 mb-4"
            >
              <div
                class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full"
              >
                <span class="mr-2">Acciones</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>

              <vs-dropdown-menu>
                <vs-dropdown-item>
                  <span class="flex items-center">
                    <feather-icon
                      icon="TrashIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Eliminar</span>
                  </span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown> -->

            <!-- ADD NEW -->
            <router-link
              to="/blog/crear"
              class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
              @click="addNewData"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary"
                >Agregar publicación</span
              >
            </router-link>
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="name">Id</vs-th>
          <vs-th sort-key="category">Por</vs-th>
          <vs-th sort-key="popularity">Título</vs-th>
          <vs-th sort-key="order_status">F. publicación</vs-th>
          <vs-th sort-key="order_status">Estado</vs-th>
          <vs-th sort-key="order_status">Tipo</vs-th>
          <vs-th>Acciones</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.id }}</p>
              </vs-td>

              <vs-td v-if="tr.User">
                <p class="product-category">{{ tr.User.name }}</p>
              </vs-td>

              <vs-td>
                <a href="" @click.prevent="verPost(tr)" class="product-category">{{ tr.title | title }}</a>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ $dayjs(tr.created_at).format('DD-MM-YYYY') }}</p>
              </vs-td>

              <vs-td>
                <custom-checkbox
                  :value="tr.estado"
                  textoCaso1="Publicado"
                  textoCaso0="Borrador"
                  @change="updateStatus('estado', $event, tr)"
                ></custom-checkbox>
              </vs-td>

              <vs-td>
                <custom-checkbox
                  :value="tr.favorito"
                  textoCaso1="Destacado"
                  textoCaso0="No destacado"
                  @change="updateStatus('favorito', $event, tr)"
                ></custom-checkbox>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <div class="flex">
                  <vx-tooltip text="Comentarios">
                    <feather-icon
                      icon="InfoIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      class="mr-2"
                      @click.stop="
                        $router.push({
                          name: 'blog-detalles-slug',
                          params: { slug: tr.slugTitle },
                        })
                      "
                    />
                  </vx-tooltip>

                  <vx-tooltip text="Editar">
                    <feather-icon
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      @click.stop="
                        $router.push({
                          name: 'blog-editar-slug',
                          params: { slug: tr.slugTitle },
                        })
                      "
                    />
                  </vx-tooltip>

                  <vx-tooltip text="Eliminar">
                    <feather-icon
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current"
                      class="ml-2"
                      @click.stop="deleteData(tr)"
                    />
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>

    <!-- <vs-table
      multiple
      v-model="selected"
      pagination
      max-items="5"
      search
      :data="posts"
    >
      <template slot="thead">
        <vs-th sort-key="id">Nro</vs-th>
        <vs-th sort-key="email">Por</vs-th>
        <vs-th sort-key="username">Título</vs-th>
        <vs-th sort-key="username">F. publicación</vs-th>
        <vs-th sort-key="username">Acciones</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].id">
            {{ data[indextr].id }}
          </vs-td>
          
          <vs-td :data="data[indextr].email">
            {{ data[indextr].User.name }}
          </vs-td>

          <vs-td :data="data[indextr].username">
            {{ data[indextr].title }}
          </vs-td>

          <vs-td :data="data[indextr].id">
            1/11/2020
          </vs-td>

          <vs-td :data="data[indextr].id">
            <vs-button color="success" type="filled">Success</vs-button>
            <vs-button color="success" type="filled">Success</vs-button>s
          </vs-td>
        </vs-tr>
      </template>
    </vs-table> -->

    <vs-popup
      :title="objectSelected.title"
      :active.sync="modalDelete"
      v-if="objectSelected"
    >
      <section class="text-center">
        <p class="mb-3">¿Está seguro de eliminar?</p>

        <div>
          <vs-button
            class="mr-3"
            color="danger"
            type="flat"
            @click="closeModal('delete')"
            >Cancelar</vs-button
          >
          <vs-button
            color="success"
            type="filled"
            @click.prevent="deleteItem()"
            >{{ loadingAction ? "Eliminando" : "Eliminar" }}</vs-button
          >
        </div>
      </section>
    </vs-popup>
  </vx-card>
</template>

<script>
import { mapState } from 'vuex'

import GetAllBlog from '@/apollo/queries/blog/GetAllBlog.gql'
import DeleteBlog from '@/apollo/mutations/blog/DeleteBlog.gql'
import UpdateBlog from '@/apollo/mutations/blog/UpdateBlog.gql'

export default {
  data () {
    return {
      posts: [],
      selected: [],
      itemsPerPage: 50,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      modalDelete: false,
      objectSelected: null,
      loadingAction: false,
      number_paginate: 100,
      page: 1
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$apollo.query({
        query: GetAllBlog,
        fetchPolicy: 'no-cache',
        variables: {
          number_paginate: this.number_paginate,
          page: this.page,
          estado: ""
        }
      })
      .then(response => this.posts = response.data.GetAllBlog.data)
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData (item) {
      this.modalDelete = true

      this.objectSelected = item
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getStatusColor (status) {
      return status == 1 ? 'success' : 'danger'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    closeModal(type) {
      type === 'delete' ? this.modalDelete = false : this.modalEdit = false

      this.objectSelected = null
    },
    updateStatus(type, event, item) {
      let status = event.target.checked === true ? 1 : 0

      let input = {
        "id": parseInt(item.id)
      }

      type === 'estado' ? input.estado = parseInt(status) : input.favorito = parseInt(status)

      this.$apollo.mutate({
        mutation: UpdateBlog,
        variables: {
          input
        }
      })
      .then(() => {
        type === 'estado' ? item.estado = status : input.favorito = item.favorito = status

        this.$vs.notify({
            title: "Estado actualizado",
            color: "success",
            position: "top-right",
          })
      })
    },
    deleteItem() {
      this.loadingAction= true

      this.$apollo.mutate({
        mutation: DeleteBlog,
        variables: {
          input: {
            id: parseInt(this.objectSelected.id)
          }
        }
      })
      .then(() => {
        this.loadingAction = false

        this.modalDelete = false

        this.objectSelected = null

        this.getData()
      })
    },
    verPost(item) {
      window.open(`https://kirasportswear.com/blog/${item.slugTitle}`)
    }
  },
  computed: {
    ...mapState(['currentUser', 'currentUserData'])
  }
};
</script>

<style lang="scss" scoped>
</style>